const config = {
    build_number: '601180',
    build_timestamp: '2025-04-25T21:00:58.089Z',
    build_commit: '2ab1c04e1b25e49aaf16fff43817bd3fe5b6b879',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
